export class Step1Data {
	constructor() {
		this.birthDate = null;
		this.citizenOrResident = null;
		this.residentMoreThan3Years = null;
		this.militaryService = null;
		this.captchaToken = null;

		this.selectedCity = -1;
		this.selectedStreet = -1;
	}

	public birthDate?: Date;
	public citizenOrResident?: string;
	public residentMoreThan3Years?: boolean;
	public militaryService?: boolean;

	public selectedCity: number;
	public selectedStreet: number;

	public captchaToken: string = null;

	public get birthDateString() { return new Date(this.birthDate).toDateString(); }

	//public get birthDate() { return new Date().getTime();}

	getYear() {
		// return this.birthDate ? new Date(this.birthDate).getFullYear() : -1 ;
		return this.birthDate ? this.birthDate.getFullYear() : -1 ;
	}
	getMonth() {
		return this.birthDate ? this.birthDate.getMonth()+1 : -1;
	}
	getDay() {
		return this.birthDate ? this.birthDate.getDate() : -1;
	}

	public static isValidDate(year, month, day) {
		if (year <= 0)
			return false;
		var d = new Date(year, month-1, day);
		return d && (d.getMonth() + 1) == month;
	}

	setDate(year, month, day) {
		//alert(year + ' ' + month + ' ' + day);
		day = day || this.getDay();
		if (year > 0 && month > 0 && day > 0) {
			//debugger;
			if (Step1Data.isValidDate(year, month, day)) {
				this.birthDate = new Date(year, month - 1, day);
				this.birthDate.setHours(this.birthDate.getHours() - this.birthDate.getTimezoneOffset() / 60);
				return true; //valid date
			}
			//else {
			//	console.log(selectedDay);
			//	//selectedDay['valid'] = false; //Cannot set property valid of [object Object] which has only a getter
			//}
		}

		return false; // invalid date
	}

}



// WEBPACK FOOTER //
// ./src/app/step1-calc/Step1-DataModel.ts